import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchInventoriesCount() {
  const { data } = await http(`/admin/product-inventories-count`);

  return data;
}

export function useInventoriesCount() {
  const { data, ...raResult } = useQuery(["product-groups"], () =>
    fetchInventoriesCount()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
